var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconFlagCanadamin = function SvgIconFlagCanadamin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M10.667 10.333A2.667 2.667 0 0 0 8 13v12a2.667 2.667 0 0 0 2.667 2.667h4V10.333zm18.666 0h-4v17.334h4A2.667 2.667 0 0 0 32 25V13a2.667 2.667 0 0 0-2.667-2.667"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M14.667 10.333h10.666v17.334H14.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M20.41 21.742c.799.093 1.515.176 2.313.267l-.204-.668a.31.31 0 0 1 .106-.317l2.32-1.89-.48-.225c-.212-.076-.154-.195-.077-.482l.354-1.29-1.347.284c-.132.02-.219-.063-.239-.143l-.174-.607-1.065 1.196c-.152.192-.458.192-.363-.251l.455-2.423-.611.317c-.171.096-.343.112-.438-.06l-.843-1.577v.04-.04l-.844 1.578c-.096.171-.267.155-.438.059l-.611-.317.455 2.423c.096.443-.211.443-.362.25l-1.066-1.195-.173.608c-.02.08-.108.163-.24.143l-1.347-.285.354 1.291c.076.287.134.406-.077.481l-.48.226 2.32 1.89c.091.071.138.2.105.317l-.204.668 2.314-.267c.07 0 .117.039.116.12l-.142 2.47h.637l-.142-2.47c.001-.082.047-.121.118-.121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.227451 0 0 0 0 0.223529 0 0 0 0 0.266667 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6288_15828"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6288_15828",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconFlagCanadamin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_flag_canada.min.dc6cf9c4e68ad07fb8bab5ca320bf0fc.svg";